import { forwardRef } from "react";
import './InputMask.scss';
import { InputMask as PrInputMask } from 'primereact/inputmask'
import classNames from "classnames";


const InputMask = forwardRef(({className, ...props}, ref) => {
  
  return (
    <PrInputMask ref={ref} className={classNames('InputMask', className)} {...props} />
  )
})

export default InputMask